import React, { useEffect } from "react";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Form,
  Col,
  Select,
  DatePicker,
  Divider,
  Space,
  Descriptions,
  Button,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { SearchOutlined } from "@ant-design/icons";

//OTHER IMPORTS
import dayjs from "dayjs";

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import { labelConfig } from "../../../../customer.config";

const { Title } = Typography;

const DetailForm = (props) => {
  const {
    onSearch,
    currencyData,
    displayFields,
    customerInfo,
    showDetailsForm,
    handleSearchInTable,
    onFinish,
    form,
    onChangeProduct,
    productData,
    fieldOfficerData,
  } = props;
  const dateFormat = "YYYY/MM/DD";

  useEffect(() => {
    defaultDate();
  }, []);

  const defaultDate = () => {
    form.setFieldsValue({
      submittedOnDate: dayjs(),
    });
  };

  const disabledAfterCurrentDate = (current) => {
    return current && current.valueOf() > Date.now();
  };

  const items = [
    {
      label: labelConfig.customerType,
      children: customerInfo ? customerInfo.entityType : "-",
    },
    {
      label: labelConfig.customerName,
      children: customerInfo ? customerInfo.entityName : "-",
    },
    {
      label: labelConfig.mobileNumber,
      children: customerInfo ? customerInfo.entityMobileNo : "-",
    },
    {
      label: labelConfig.customerNumber,
      children: customerInfo ? customerInfo.entityAccountNo : "-",
    },
  ];

  return (
    <Form layout="vertical" onFinish={onFinish} form={form}>
      <Row>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.customerInfo}
          </Title>
        </Divider>
        <Col span={12} style={{ padding: "0px 8px" }}>
          <Space.Compact
            style={{
              width: "100%",
            }}
          >
            <div>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search Client by: Customer ID/Mobile Number"
                style={{ width: 400 }}
                allowClear
              />
            </div>
            <Button type="primary" className="of-primaryBtnColor" onClick={onSearch}>
              <SearchOutlined />
            </Button>
          </Space.Compact>
        </Col>
      </Row>
      {showDetailsForm && (
        <>
          <Descriptions
            bordered
            column={{
              xs: 1,
              sm: 2,
              md: 2,
              lg: 2,
              xl: 2,
              xxl: 2,
            }}
            style={{ marginTop: 10, marginBottom: 20 }}
            items={items}
          />

          <Row>
            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.generalInfo}
              </Title>
            </Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.product}
                name="productId"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.product),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.product, "select")}
                  options={productData}
                  showSearch
                  onChange={onChangeProduct}
                  allowClear
                />
              </Form.Item>
            </Col>
            {displayFields && (
              <>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={labelConfig.accountOfficer} name="fieldOfficerId">
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                      }
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.accountOfficer, "select")}
                      options={fieldOfficerData}
                      showSearch
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.currency}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.currency),
                      },
                    ]}
                  >
                    <Input
                      disabled
                      value={`${currencyData.name ? currencyData.name : ""}${
                        currencyData.code ? ` (${currencyData.code})` : " - "
                      }`}
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.currency)}
                      className="of-bold-disable-input"
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.decimalPlaces}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.decimalPlaces),
                      },
                    ]}
                  >
                    <Input
                      disabled
                      value={`${currencyData.decimalPlaces ? currencyData.decimalPlaces : "-"}`}
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.decimalPlaces)}
                      className="of-bold-disable-input"
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.currencyInMultiplesOf}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.currencyInMultiplesOf),
                      },
                    ]}
                  >
                    <Input
                      disabled
                      value={`${currencyData.inMultiplesOf ? currencyData.inMultiplesOf : " - "}`}
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.currencyInMultiplesOf)}
                      className="of-bold-disable-input"
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.submittedOn}
                    name="submittedOnDate"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.submittedOn),
                      },
                    ]}
                  >
                    <DatePicker
                      disabledDate={disabledAfterCurrentDate}
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.submittedDate, "select")}
                      style={{ width: "100%", height: 32.5 }}
                      format={dateFormat}
                    />
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>
        </>
      )}
    </Form>
  );
};

export default DetailForm;
